export const h = {
  navMenu: ["STARTSEITE","PRÄMIEN", "HELDEN", "SPIELMERKMALE"],

}



// WEBPACK FOOTER //
// ./src/i18n/lan/de.js